module.exports = __webpack_public_path__ + "static/heavy_ugl6-593b1ab2e0bb2c8002371ad8f1c893ff.jpg";